import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tn"
  }, [_c('div', {
    staticClass: "tn_toolbar"
  }, [_c('b-form-select', {
    staticClass: "tn_select",
    attrs: {
      "options": _vm.accountOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.load
    },
    model: {
      value: _vm.accountId,
      callback: function callback($$v) {
        _vm.accountId = $$v;
      },
      expression: "accountId"
    }
  }), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" 重新整理 ")]), _vm.fetchedAtText ? _c('span', {
    staticClass: "tn_stamp"
  }, [_vm._v(" 資料時間 " + _vm._s(_vm.fetchedAtText) + " "), _vm.statusNote ? _c('b-badge', {
    staticClass: "ml-1",
    attrs: {
      "variant": _vm.statusNote.variant,
      "title": _vm.statusNote.hint
    }
  }, [_vm._v(" " + _vm._s(_vm.statusNote.text) + " ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._l(_vm.errors, function (e, i) {
    return _c('b-alert', {
      key: "err".concat(i),
      staticClass: "mx-1 my-2 py-2",
      attrs: {
        "show": "",
        "variant": "danger"
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle mr-1"
    }), _vm._v(" " + _vm._s(e.accountId) + "：" + _vm._s(e.msg) + " ")]);
  }), _vm.loading && !_vm.plants.length ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : _vm._e(), _c('b-alert', {
    staticClass: "text-center mx-1 my-4",
    attrs: {
      "show": !_vm.loading && !_vm.plants.length && !_vm.errors.length,
      "variant": "secondary"
    }
  }, [_vm._v(" 目前沒有資料，請洽資訊人員確認資料收集狀態。 ")]), _vm.plants.length ? [_c('div', {
    staticClass: "tn_kpis"
  }, _vm._l(_vm.kpis, function (k) {
    return _c('div', {
      key: k.label,
      staticClass: "tn_kpi",
      class: k.tone
    }, [_c('div', {
      staticClass: "tn_kpi_label"
    }, [_vm._v(_vm._s(k.label))]), _c('div', {
      staticClass: "tn_kpi_value"
    }, [_vm._v(_vm._s(k.value)), _c('small', [_vm._v(_vm._s(k.unit))])])]);
  }), 0), _c('div', {
    staticClass: "tn_section"
  }, [_c('div', {
    staticClass: "tn_sectionTitle"
  }, [_c('i', {
    staticClass: "fas fa-triangle-exclamation"
  }), _vm._v(" 異常與提示 "), _vm.faultCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger",
      "pill": ""
    }
  }, [_vm._v("故障 " + _vm._s(_vm.faultCount))]) : _vm._e(), _vm.warnCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "warning",
      "pill": ""
    }
  }, [_vm._v("注意 " + _vm._s(_vm.warnCount))]) : _vm._e(), _vm.infoCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary",
      "pill": ""
    }
  }, [_vm._v("提示 " + _vm._s(_vm.infoCount))]) : _vm._e(), !_vm.allAlerts.length ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "success",
      "pill": ""
    }
  }, [_vm._v("0")]) : _vm._e(), _c('small', {
    staticClass: "tn_hint"
  }, [_vm._v("故障要立刻處理，注意是相對比較，提示只是說明數字為何偏低")])], 1), !_vm.allAlerts.length ? _c('div', {
    staticClass: "tn_empty"
  }, [_c('i', {
    staticClass: "fas fa-circle-check"
  }), _vm._v(" 目前所有案場都正常 ")]) : _c('div', {
    staticClass: "tn_alerts"
  }, _vm._l(_vm.allAlerts, function (a, i) {
    return _c('div', {
      key: "a".concat(i),
      staticClass: "tn_alert",
      class: "is-".concat(a.level),
      on: {
        "click": function click($event) {
          return _vm.focusPlant(a.plantNo);
        }
      }
    }, [_c('div', {
      staticClass: "tn_alert_head"
    }, [_c('span', {
      staticClass: "tn_dot",
      class: "is-".concat(a.level)
    }), _vm._v(" " + _vm._s(a.plantName) + " "), _c('small', {
      staticClass: "tn_alert_acc"
    }, [_vm._v(_vm._s(a.accountId))])]), _c('div', {
      staticClass: "tn_alert_target"
    }, [_vm._v(_vm._s(a.target))]), _c('div', {
      staticClass: "tn_alert_msg"
    }, [_vm._v(_vm._s(a.msg))])]);
  }), 0)]), _c('div', {
    staticClass: "tn_section"
  }, [_c('div', {
    staticClass: "tn_sectionTitle"
  }, [_c('i', {
    staticClass: "fas fa-industry"
  }), _vm._v(" 案場（" + _vm._s(_vm.plants.length) + "） "), _c('small', {
    staticClass: "tn_hint"
  }, [_vm._v("點卡片展開逐台逆變器比較")])]), _c('div', {
    staticClass: "tn_plants"
  }, _vm._l(_vm.sortedPlants, function (p) {
    return _c('div', {
      key: _vm.plantKey(p),
      ref: "plant-".concat(p.plantNo),
      refInFor: true,
      staticClass: "tn_plant",
      class: ["is-".concat(p.level), {
        'is-focus': _vm.focusedPlant === p.plantNo,
        'is-open': !!_vm.opened[_vm.plantKey(p)]
      }]
    }, [_c('div', {
      staticClass: "tn_plant_head",
      on: {
        "click": function click($event) {
          return _vm.toggle(p);
        }
      }
    }, [_c('span', {
      staticClass: "tn_dot",
      class: "is-".concat(p.level)
    }), _c('span', {
      staticClass: "tn_plant_name"
    }, [_vm._v(_vm._s(p.name))]), _c('b-badge', {
      staticClass: "tn_plant_acc",
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(p.accountId))]), p.weatherStatus ? _c('span', {
      staticClass: "tn_weather"
    }, [_vm._v(" " + _vm._s(p.weatherStatus) + " "), p.temperature != null ? [_vm._v("· " + _vm._s(p.temperature) + "°C")] : _vm._e()], 2) : _vm._e(), _c('i', {
      staticClass: "fas ml-auto",
      class: _vm.opened[_vm.plantKey(p)] ? 'fa-chevron-up' : 'fa-chevron-down'
    })], 1), _c('div', {
      staticClass: "tn_plant_body"
    }, [_c('div', {
      staticClass: "tn_figures"
    }, [_c('div', {
      staticClass: "tn_figure"
    }, [_c('span', [_vm._v("今日發電")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.energyToday, 1)))]), _vm._v(" kWh ")]), _c('div', {
      staticClass: "tn_figure"
    }, [_c('span', [_vm._v("即時發電功率")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.instantPower, 1)))]), _vm._v(" kW ")]), _c('div', {
      staticClass: "tn_figure"
    }, [_c('span', [_vm._v("等效小時")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.yieldToday, 2)))]), _vm._v(" h ")]), _c('div', {
      staticClass: "tn_figure"
    }, [_c('span', [_vm._v("日照")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.irradianceNow, 0)))]), _vm._v(" W/m² ")])]), _c('div', {
      staticClass: "tn_metric"
    }, [_c('div', {
      staticClass: "tn_metric_top"
    }, [_c('span', [_vm._v(" 今日 PR "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-circle-info tn_info",
      attrs: {
        "title": "監控平台的日 PR 隔日才產生，本欄為「等效小時 ÷ 當日累積日照」即時計算"
      }
    })]), _c('b', {
      class: _vm.prClass(p.prToday)
    }, [_vm._v(_vm._s(p.prToday == null ? '—' : p.prToday + '%'))])]), _c('div', {
      staticClass: "tn_bar"
    }, [_c('div', {
      staticClass: "tn_bar_fill",
      class: _vm.prClass(p.prToday),
      style: {
        width: _vm.pct(p.prToday, 100)
      }
    })])]), p.hourly.length ? _c('highcharts', {
      staticClass: "tn_chart",
      attrs: {
        "options": _vm.todayChart(p)
      }
    }) : _c('div', {
      staticClass: "tn_noChart"
    }, [_vm._v("今日尚無小時資料")]), _c('div', {
      staticClass: "tn_lastDaily"
    }, [p.lastDaily ? [_c('span', [_vm._v(_vm._s(p.lastDaily.date) + " 官方 PR")]), _c('b', {
      class: _vm.prClass(p.lastDaily.pr)
    }, [_vm._v(_vm._s(_vm.fmt(p.lastDaily.pr, 1)) + "%")]), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("RA")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.lastDaily.ra, 1)) + "%")]), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("資料可用率")]), _c('b', {
      class: p.lastDaily.dataAvailability < 90 ? 'is-warn' : ''
    }, [_vm._v(" " + _vm._s(_vm.fmt(p.lastDaily.dataAvailability, 1)) + "% ")])] : [_vm._v("尚無官方日資料")]], 2)], 1), _c('b-collapse', {
      attrs: {
        "visible": !!_vm.opened[_vm.plantKey(p)]
      }
    }, [_c('div', {
      staticClass: "tn_detail"
    }, [_c('div', {
      staticClass: "tn_detailTitle"
    }, [_vm._v("近 7 日 PR 與資料可用率")]), p.daily.length ? _c('highcharts', {
      staticClass: "tn_chart",
      attrs: {
        "options": _vm.weekChart(p)
      }
    }) : _c('div', {
      staticClass: "tn_noChart"
    }, [_vm._v("尚無日資料")]), _c('div', {
      staticClass: "tn_detailTitle"
    }, [_vm._v(" 逐台逆變器比較 "), _vm.detail[_vm.plantKey(p)] ? _c('small', [_vm._v("（" + _vm._s(_vm.detail[_vm.plantKey(p)].date) + "，PR 中位數 " + _vm._s(_vm.fmt(_vm.detail[_vm.plantKey(p)].medianPr, 1)) + "%）")]) : _vm._e()]), _vm.detailLoading[_vm.plantKey(p)] ? _c('b-spinner', {
      staticClass: "my-2",
      attrs: {
        "small": "",
        "variant": "secondary"
      }
    }) : _vm.detailError[_vm.plantKey(p)] ? _c('b-alert', {
      staticClass: "py-2 my-2",
      attrs: {
        "show": "",
        "variant": "warning"
      }
    }, [_vm._v(" " + _vm._s(_vm.detailError[_vm.plantKey(p)]) + " ")]) : _vm.detail[_vm.plantKey(p)] ? _c('div', {
      staticClass: "tn_tableWrap"
    }, [_c('table', {
      staticClass: "tn_table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("逆變器")]), _c('th', [_vm._v("型號")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("容量 kWp")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("發電 kWh")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("等效小時")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("PR %")]), _c('th', [_vm._v("相對表現")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("轉換效率 %")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("可用率 %")])])]), _c('tbody', _vm._l(_vm.detail[_vm.plantKey(p)].inverters, function (inv) {
      return _c('tr', {
        key: inv.deviceNo,
        class: {
          'row-laggard': inv.laggard
        }
      }, [_c('td', [inv.laggard ? _c('i', {
        staticClass: "fas fa-arrow-trend-down is-fault mr-1"
      }) : _vm._e(), _vm._v(" " + _vm._s(inv.name) + " ")]), _c('td', {
        staticClass: "tn_vendor"
      }, [_vm._v(_vm._s(inv.vendor || '—'))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.capacity, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.energy, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.yield, 2)))]), _c('td', {
        staticClass: "text-right"
      }, [_c('b', {
        class: inv.laggard ? 'is-fault' : ''
      }, [_vm._v(_vm._s(_vm.fmt(inv.pr, 1)))])]), _c('td', {
        staticClass: "tn_miniBarCell"
      }, [_c('div', {
        staticClass: "tn_miniBar"
      }, [_c('div', {
        staticClass: "tn_miniBar_fill",
        class: {
          'is-low': inv.laggard
        },
        style: {
          width: _vm.pct(inv.pr, _vm.maxPr(_vm.detail[_vm.plantKey(p)].inverters))
        }
      })])]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.eff, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.productionAvailability, 1)))])]);
    }), 0)])]) : _vm._e(), p.events.length ? _c('div', {
      staticClass: "tn_eventList"
    }, [_c('div', {
      staticClass: "tn_detailTitle"
    }, [_vm._v("進行中事件")]), _vm._l(p.events, function (e, i) {
      return _c('div', {
        key: "e".concat(i),
        staticClass: "tn_event",
        class: "is-".concat(e.level)
      }, [_c('span', {
        staticClass: "tn_dot",
        class: "is-".concat(e.level)
      }), _c('b', [_vm._v(_vm._s(e.deviceName))]), _c('span', {
        staticClass: "tn_eventCat"
      }, [_vm._v(_vm._s(e.categoryLabel))]), _vm._v(" " + _vm._s(e.msg) + " "), e.code ? _c('small', [_vm._v("（" + _vm._s(e.code) + "）")]) : _vm._e(), _c('small', {
        staticClass: "ml-auto"
      }, [_vm._v(_vm._s(e.start))])]);
    })], 2) : _vm._e()], 1)])], 1);
  }), 0)])] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };